$ = require 'jquery'
AutoMentionerView = require 'app/scripts/views/internal/autocomplete/auto-mentioner-view'
EmojiCompleterView = require 'app/scripts/views/internal/autocomplete/emoji-completer-view'
Dates = require 'app/scripts/lib/dates'
DragSort = require 'app/scripts/views/lib/drag-sort'
hasSelectionIn = require 'app/scripts/lib/util/selection/has-selection-in'
Layout = require 'app/scripts/views/lib/layout'
PopOver = require 'app/scripts/views/lib/pop-over'
Util = require 'app/scripts/lib/util'
{ featureFlagClient } = require '@trello/feature-flag-client'
{ asNumber } = require 'app/common/lib/util/i18n/formatters'
{ TrelloStorage } = require '@trello/storage'
{ track, trackUe } = require '@trello/analytics'
t = require('app/scripts/views/internal/teacup-with-helpers')('checklist_item')
l = require 'app/scripts/lib/localize'
log = require 'app/scripts/debug/log'
{ isSubmitEvent, getKey, Key } = require '@trello/keybindings'

editTemplate = t.renderable ({ hasNewOverflowMenu })  ->
  t.div '.edit-controls.u-clearfix', ->
    t.input '.primary.confirm.mod-submit-edit.js-save-edit', { type: 'submit', value: t.l('save') }
    t.a '.icon-lg.icon-close.dark-hover.cancel.js-cancel-edit', { href: '#' }

    t.div '.edit-controls-spacer'

    t.a '.option.check-item-options-menu.dark-hover.js-assign.hide', { href: '#' }

    t.a '.option.check-item-options-menu.dark-hover.js-due.checklist-add-controls-due.hide', { href: '#' }

    t.a '.option.check-item-options-menu.dark-hover.js-open-emoji-selector', { href: '#' }, ->
      t.span '.icon-sm.icon-emoji'

    t.a '.option.check-item-options-menu.dark-hover.js-open-mention-selector', { href: '#' }, ->
      t.span '.icon-sm.icon-mention'

    if hasNewOverflowMenu ##currently the options menu is only used for CheckItems. If another use is added, add check for Checkitem
      t.div '.check-item-new-menu.ignore-editable-view.js-overflow-button-react'

    else
      t.a '.option.check-item-options-menu.dark-hover.js-open-menu', { href: '#' }, ->
          t.span '.icon-sm.icon-overflow-menu-horizontal'

editAssignTemplate = t.renderable (fullName) ->
  t.icon 'add-member'
  if fullName
    t.text(fullName)
  else
    t.format('assign')

editDueTemplate = t.renderable (dueText) ->
  t.icon 'clock'
  if dueText
    t.text(dueText)
  else
    t.format('due-date')

module.exports._checkItemDraftKey = -> "draft_#{ @model.id }_name"
module.exports._saveCheckItemDraft = (attr, value) -> TrelloStorage.set(@_checkItemDraftKey(attr), value)
module.exports._recallCheckItemDraft = -> TrelloStorage.get(@_checkItemDraftKey('name'))
module.exports._discardCheckItemDraft = -> TrelloStorage.unset(@_checkItemDraftKey('name'))

module.exports.saveCheckItemDrafts =  (invokeSource) ->
  return false if !@model.id?

  for $el in @getCheckItemEdits()
    attr = $el.attr('attr')
    val = $el.find('.js-checkitem-input:first').val()
    continue if $.trim(val).length == 0 # Not in edit mode

    if @model.get('name') != val && val != @_recallCheckItemDraft()
      if invokeSource
        track('Editable View', 'Save Draft', "Save draft via #{invokeSource}")
        trackUe('Editable View', 'Save Draft', '', '', '', "when #{invokeSource}", '')
      @_saveCheckItemDraft(attr, val)

module.exports.recallCheckItemDrafts = ->
  @getCheckItemEdits().each (i, $el) =>
    if @model.id?
      draftVal = @_recallCheckItemDraft()
      if draftVal?
        $input = $el.find('.field:first')
        $input.val(draftVal)
        @defer =>
          $el.find('.edits-warning').show()

module.exports.getCheckItemEdits =  ->
    $allEdits = @$('[attr]')
    # Make sure we don't process other editables that are nested
    # inside this one
    $noEdits = @$('.js-no-higher-edits [attr]')

    $allEdits.not($noEdits).map (index, el) => $(el)

module.exports.onCheckItemClick = (e) ->
    $link = $(e.target).closest('a')
    return if ($link.length > 0 && $link.attr('href') != '#')
    return if DragSort.sorting

    $noEditableView = $(e.target).closest('.ignore-editable-view')
    if $noEditableView.length > 0
      return

    $container = $(e.target).closest('.editable')
    if $container.length == 0
      return

    # If they've selected some text, they're probably trying to copy it
    if hasSelectionIn($container)
      return

    Util.stop(e)
    PopOver.hide()

    attr = $container.attr('attr')

    @editCheckItem(attr)

module.exports.checkItemKeydownEvent = (e) ->
    if $('.editing').length > 0

     if (PopOver.view instanceof EmojiCompleterView) || (PopOver.view instanceof AutoMentionerView)
        @checkInsert(e)

     else if isSubmitEvent(e)
        @commitCheckItemEdits(e)

    return

module.exports.checkItemEditControlKeydown = (e) ->
    if getKey(e) == Key.Escape
        Util.stop(e)

        if PopOver.isVisible
          PopOver.hide()
          return
        else
          @clearEdits(e)
        return

module.exports.clearEdits = (e) ->
    Util.stop(e)
    $editable = $(e.target).closest('.editable[attr]')

    @_discardCheckItemDraft('name')

    $editable.find('.js-checkitem-input').val("")
    $editable.find('.edits-warning').hide()
    $editable.find('.edits-error').hide()
    $editable.removeClass('editing')
    Layout.cancelEdits()
    false

module.exports.renderEditItemButtons = ->
    $editControls = @$('.edit-controls')
    if $editControls.length
      idMember = @model.get('idMember')
      due = @model.get('due')

      fullName = idMember && @modelCache.get('Member', idMember)?.get('fullName')
      $editControls.find('.js-assign').html(editAssignTemplate(fullName))

      dueText = due && Dates.toDateString(due)
      $editControls.find('.js-due').html(editDueTemplate(dueText))

    @

module.exports.commitCheckItemEdits = (e) ->
    PopOver.hide()

    if @$('.js-checkitem-input').val().length == 0
      @model.destroy()
    else
      prevName = @model.get('name')
      Util.stop(e) if e

    $editable = $(e.target).closest('.editable.editing[attr]')
    $editable.find('.edits-error').hide()

    if !@validateCheckItemInput()
      return

    view = @
    model = @model
    customSet = @customSet

    # Remove buttons
    $editable.remove('input[type=submit]')

    # Remove buttons and commit all other edits
    $editable
    .removeClass('editing')
    .each(->
      attr = $(this).attr('attr')
      newValue = $(this).find('.js-checkitem-input').val()

      if !view.allowNewlines
        newValue = newValue.replace(/[\r\n]+/g, ' ')

      # if the newValue is all whitespace, replace it with the empty string
      if $.trim(newValue).length == 0
        newValue = ""

      if model.get('name') == newValue
        view._discardCheckItemDraft('name')
      else
        model.update attr, newValue, (err) ->
          if err?
            $editable.find('.edits-error').text(err.message).show()
            view._saveCheckItemDraft(attr, newValue)
          else
            view._discardCheckItemDraft(attr)
          return
    )
    .find('.js-checkitem-input').val("")

    $editable.find('.edits-warning').hide()

    true

module.exports.validateCheckItemInput = ->
    checkItemInputValue = @$('.js-checkitem-input').val()

    if /^\s*$/.test(checkItemInputValue)
      return false

    if checkItemInputValue.length > 16384
      @$('.editing')
      .find('.edits-error')
      .text l('text too long', { over: asNumber(fieldLength - 16384) })
      .show()
      return false

    true

module.exports.editCheckItem = (sAttr) ->
   if sAttr.indexOf('.') > -1
      parts = sAttr.split('.')
      sAttr = parts[1]

    allEditableWithAttr = @$("[attr=#{sAttr}]")
    noEdits = @$(".js-no-higher-edits [attr=#{sAttr}]")
    container = allEditableWithAttr.not(noEdits)
    return if (container.length == 0)

    Layout.cancelEdits()
    edit = container.find('.edit:first')
    return if (edit.length == 0)

    input = container.find('.js-checkitem-input:first')
    current = container.find('.current')

    board = @model.getBoard()
    showButtons = Boolean(board?.hasAdvancedChecklists() || board?.upsellAdvancedChecklists())

    useNewOverflowMenu = featureFlagClient.get('remarkable.checkitem-overflow-rewrite', false)

    edit.append(editTemplate({ hasNewOverflowMenu: useNewOverflowMenu }))

    editableViewButton = @el.querySelector('.js-overflow-button-react')

    if useNewOverflowMenu
      @renderOverflowButton(editableViewButton, { editableView: true })

    @$('.js-assign,.js-due').toggleClass('hide', !showButtons)
    @renderEditItemButtons()

    container.addClass('editing')

    if input.val() == ""
      input.val(Util.traverse(@model.attributes, parts ? sAttr))

    @waitForId @model, =>
      input.data('draftKey', @_checkItemDraftKey())

    log('editable', @model)


    input.focus().select()
    input.autosize(append: false)
    return

